import { render, staticRenderFns } from "./VSwitch.vue?vue&type=template&id=463be4cb&scoped=true"
import script from "./VSwitch.vue?vue&type=script&lang=js"
export * from "./VSwitch.vue?vue&type=script&lang=js"
import style0 from "./VSwitch.vue?vue&type=style&index=0&id=463be4cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463be4cb",
  null
  
)

export default component.exports